import React, { useEffect, useState } from 'react';
import ClubbedOtpAccordion from '../ClubbedOtpAccordion/ClubbedOtpAccordion';
import "./ClubbedOtp.css";
import "./PolicyConfirmation.css";
import { clubbedOtpData } from '../../utils/staticQuestionDataForNewScreen';
import { hideProgressBar } from '../../utils/handleProgress';
import Pagination from '@material-ui/lab/Pagination';
import { Button } from 'unified-ui-components-library';

const ClubbedOtp = ({ submitHandler }) => {
    const [allInsurerDetails, setAllInsurerDetails] = useState(
        JSON.parse(localStorage.getItem("allinsurerDetails"))
    );
    // const [allInsurerDetails, setAllInsurerDetails] = useState(
    //     JSON.parse(JSON.stringify(clubbedOtpData))
    // );
    const [selectAll, setSelectAll] = useState(true);
    const [activePage, setActivePage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [pageData, setPageData] = useState(null)

    useEffect(() => {
        hideProgressBar()
        let allData = [];
        allInsurerDetails.forEach((d, index) => {
            d.checked = true;
            d.isExpanded = false
            d.id = index
            allData.push(d);
        });
        const count = Math.ceil(allData.length / 10)
        setPageCount(count)
        setAllInsurerDetails(allData);
        getCurrentPageData(1, allData);
    }, []);

    useEffect(()=>{
        getCurrentPageData(activePage, allInsurerDetails)
    }, [selectAll, allInsurerDetails])

    const handleSelectAll = (e) => {
        const { checked } = e.target;
        setSelectAll(checked);
        let allData = JSON.parse(JSON.stringify(allInsurerDetails));
        allData = allData.map((d) => {
            if (checked) {
                d.checked = true;
            } else {
                d.checked = false;
            }

            return d;
        });
        setAllInsurerDetails(allData);
    };

    const handleAccordionExpansion = (id) => {
        let allData = JSON.parse(JSON.stringify(allInsurerDetails));
        allData.map((data) => {
            if (data.id === id) {
                data.isExpanded = !data.isExpanded
            } else {
                data.isExpanded = false
            }
            return data
        })
        setAllInsurerDetails(allData);
    }

    const handleSelect = (e, id) => {
        const { checked } = e.target;
        let currentSelectedItems = 0;
        const allData = JSON.parse(JSON.stringify(allInsurerDetails));
        const item = allData.filter(ad => ad.id === id);
        item[0].checked = checked;

        allData.forEach((ad) => {
            if (ad.checked) {
                currentSelectedItems++;
            }
        });

        if (currentSelectedItems == allData.length) {
            setSelectAll(true);
        } else {
            setSelectAll(false);
        }

        setAllInsurerDetails(allData);
    };

    const handleSubmit = () => {
        let allData = JSON.parse(JSON.stringify(allInsurerDetails));
        let selectedData = allData.filter((d) => d.checked == true);
        selectedData = selectedData.map((sd) => {
            delete sd.checked;
            delete sd.id;
            delete sd.isExpanded;
            return sd;
        });
        submitHandler(selectedData);
    };

    const handlePageChange = (e, value) => {
        const paginationContainer = document.querySelector('.pagination-main-container')
        paginationContainer.scrollTo(0, 0)
        setActivePage(value)
        getCurrentPageData(value, allInsurerDetails)
        console.log(" EVENT ", value)
    }

    const generateNoOfItemLabel = () => {
        if (((activePage) * 10) > allInsurerDetails.length) {
            return `${((activePage - 1) * 10) + 1} - ${allInsurerDetails.length}`
        }
        return `${((activePage - 1) * 10) + 1} - ${(activePage) * 10}`
    }

    const getCurrentPageData = (pageNumber, data) => {
        const allData = JSON.parse(JSON.stringify(data))
        const currentPageData = allData.slice((pageNumber - 1) * 10, pageNumber*10)
        setPageData(currentPageData)
    }

    const isSubmitDisabled = () =>{
        return !allInsurerDetails.some((d) => d.checked)
    }

    return (
        <>
            <h4 className="hd-pol">Policy Confirmation</h4>
            <div className="pol-conf-wrapper">
                <div className="firstRow">
                    <div className="row">
                        <div className="col col-check">
                            <input
                                type="checkbox"
                                id="myCheckbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                            />
                            <label htmlFor="myCheckbox" id="labelCheckbox">Select All</label>
                        </div>
                        <div className="col">
                            <div className="no-of-page">Showing {generateNoOfItemLabel()} of {allInsurerDetails.length}</div>
                        </div>
                    </div>
                </div>
                <div
                    className='pagination-main-container'
                >
                    {pageData?.map((data, index) => (
                        <ClubbedOtpAccordion
                            key={index}
                            data={data}
                            handleSelect={handleSelect}
                            handleAccordionExpansion={handleAccordionExpansion}
                        />
                    ))}
                </div>
                <Pagination onChange={handlePageChange} count={pageCount} />
                <div className="clubbed-button-container">
                    <Button
                        disabled={isSubmitDisabled()}
                        onClick={handleSubmit}
                        buttonType='primary'
                        width="264"
                    >
                        Next
                    </Button>
                </div>
            </div>
        </>
    )
}

export default ClubbedOtp